import OperationalSLAActionTypes from './action-types';

const initialState = {
  data: [],
  matchLocation:[],
  columns: [
  {
    name: 'Tipo',
    description: 'Tipo de SLA (Operacional ou Transporte) que será importado',
  },  
  {
    name: 'Fornecedor',
    description: 'Empresa responsável pelo fornecimento da mercadoria.',
  },
  {
    name: 'SLA Produção',
    description: 'Tempo necessário até a mercadoria estar pronta para envio.',
  },
  {
    name: 'Operação',
    description: 'Tipo de Operação (Aéreo, Marítimo ou Rodoviário) do embarque',
  },
  {
    name: 'Modal',
    description: 'Modal utilizado para o transporte, como marítimo, aéreo ou rodoviário.',
  },
  {
    name: 'Local de Partida',
    description: 'Local de origem da mercadoria.',
  },
  {
    name: 'Local de Chegada',
    description: 'Destino final da mercadoria.',
  },
  {
    name: 'Pré-Embarque',
    description: 'Duração do período Pré-Embarque.',
  },
  {
    name: 'Transporte Internacional',
    description: 'Duração do transporte internacional.',
  },
  {
    name: 'Desembaraço',
    description: 'Tempo estimado para o processo de liberação aduaneira.',
  },
  {
    name: 'Logística Internacional',
    description: 'Duração do período Logística Internacional.',
  },
  {
    name: 'Faturamento',
    description: 'Tempo estimado para emissão de fatura após entrega ou liberação.',
  },
  ],
  currentStep: 1,
  loading: false,
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case OperationalSLAActionTypes.LOAD_FILE_IMPORT:
      return {
        ...state,
        data: action.payload,
      };
    case OperationalSLAActionTypes.NEXT_STEP:
      return {
        ...state,
        currentStep: state.currentStep + 1,
      };
    case OperationalSLAActionTypes.PREV_STEP:
      return {
        ...state,
        currentStep: state.currentStep - 1,
      };
    case OperationalSLAActionTypes.CANCEL_IMPORT:
      return initialState;
    // case ShipmentActionTypes.LOAD_MATCH_LOCATION:
    //   return {
    //     ...state,
    //     matchLocation: action.payload,
    //   };
    case OperationalSLAActionTypes.LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    default:
      return state;
  }
};

export default userReducer;
